import { DashboardDataResult } from 'src/apps/dashboard/services/queries/dashboard/helpers/transformResults';
import { ScoreDataResult } from 'src/apps/dashboard/services/queries/score/helpers/transformResults';
import { QueryState } from 'src/apps/dashboard/types/TemplateProps';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';

export const ISSUES_PAGE_TABS_ID = 'issues-page-tabs';

export const ISSUES_TAB_IDS = {
	ALL: 'all-issues',
	UNIQUE: 'unique-issues'
} as const;

export const ISSUES_TABLE_SKELETON_ROW_COUNT = 7;

export const ISSUES_PAGE_FILTER_PRESET = 'issues' as const;

export const ISSUES_PAGE_BOTTOM_KIND = 'tabs' as const;

const ISSUES_PAGE_CONSTANTS = {
	TITLE: 'Issues Across Sessions',
	TITLE_ID: 'issues-page-title',
	DESCRIPTION: 'View a full list of issues or focus on unique issues. The table updates live.',
	DESCRIPTION_ID: 'issues-page-description',
	BACK_BUTTON_TEXT: 'Back to Web Dashboard'
} as const;

export const HEADER = {
	title: ISSUES_PAGE_CONSTANTS.TITLE,
	titleId: ISSUES_PAGE_CONSTANTS.TITLE_ID,
	description: ISSUES_PAGE_CONSTANTS.DESCRIPTION,
	descriptionId: ISSUES_PAGE_CONSTANTS.DESCRIPTION_ID,
	backLink: {
		url: RoutesHelper.getAccessibilityDashboardPath(),
		text: ISSUES_PAGE_CONSTANTS.BACK_BUTTON_TEXT
	}
};

export const EMPTY_SCORE_QUERY: QueryState<ScoreDataResult> = {
	data: undefined,
	isLoading: false,
	error: null
};

export const EMPTY_DASHBOARD_QUERY: QueryState<DashboardDataResult> = {
	data: undefined,
	isLoading: false,
	error: null
};
